import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { FeelsMoreConfidentEnum } from '@isophi/pap-api';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'isophi-app-emoji-rating',
    templateUrl: './emoji-rating.component.html',
    styleUrls: ['./emoji-rating.component.scss'],
    standalone: false
})
export class EmojiRatingComponent {
  @Input() control: FormControl<FeelsMoreConfidentEnum | null>;
  @Output() valueChange = new EventEmitter<FeelsMoreConfidentEnum>();

  translocoService = inject(TranslocoService);

  readonly options: { value: FeelsMoreConfidentEnum; icon: string; iconActive: string; label: string }[] = [
    {
      value: FeelsMoreConfidentEnum.StronglyDisagree,
      icon: 'assets/img/emojis/smile-no.svg',
      iconActive: 'assets/img/emojis/smile-no-active.svg',
      label: this.translocoService.translate('shared/no')
    },
    {
      value: FeelsMoreConfidentEnum.Disagree,
      icon: 'assets/img/emojis/smile-rather-no.svg',
      iconActive: 'assets/img/emojis/smile-rather-no-active.svg',
      label: this.translocoService.translate('shared/ratherNo')
    },
    {
      value: FeelsMoreConfidentEnum.Agree,
      icon: 'assets/img/emojis/smile-rather-yes.svg',
      iconActive: 'assets/img/emojis/smile-rather-yes-active.svg',
      label: this.translocoService.translate('shared/ratherYes')
    },
    {
      value: FeelsMoreConfidentEnum.StronglyAgree,
      icon: 'assets/img/emojis/smile-yes.svg',
      iconActive: 'assets/img/emojis/smile-yes-active.svg',
      label: this.translocoService.translate('shared/yes')
    }
  ];

  select(value: FeelsMoreConfidentEnum) {
    this.control.setValue(value);
    this.valueChange.emit(value);
  }

  isSelected(optionValue: FeelsMoreConfidentEnum): boolean {
    return this.control.value === optionValue;
  }
}
